import { takeLatest, put, call } from 'redux-saga/effects'
import { createSlice } from '@reduxjs/toolkit'

import Api from '../utils/api'

function* getUserInfo() {
  yield put(setIsLoading(true))
  yield put(setInitialized(false))
  try {
    const response = yield call(Api.get, '/users/info')
    console.log(response)
    yield put(setUserInfo(response.data.user))
    yield put(setInformInfo(response.data.informInfo))
  } catch (err) {
    console.log(err)
    yield put(setUserInfo({}))
  } finally {
    put(setIsLoading(false))
    yield put(setInitialized(true))
  }
}

export function* watchAuthSaga() {
  yield takeLatest(onGetUserInfo.type, getUserInfo)
}

export const authSlice = createSlice({
  name: 'auth',
  initialState: {
    isLoading: false,
    userInfo: {},
    informInfo: {},
    initialized: false,
  },
  reducers: {
    setIsLoading: (state, action) => {
      state.isLoading = action.payload
    },
    onGetUserInfo: () => {},
    setUserInfo: (state, action) => {
      state.userInfo = action.payload
    },
    setInformInfo: (state, action) => {
      state.informInfo = action.payload
    },
    setInitialized: (state, action) => {
      state.initialized = action.payload
    },
  },
})

export const {
  setIsLoading,
  onGetUserInfo,
  setInformInfo,
  setUserInfo,
  setInitialized,
} = authSlice.actions

export default authSlice.reducer
